<template lang="pug">
  v-dialog(v-model="show" max-width="700" :fullscreen="$vuetify.breakpoint.smAndDown" persistent scrollable)
    v-snackbar(v-model="showSnackBar" :color="snackBarColor") {{ snackBarMessage }}
      template(v-slot:action="{ attrs }")
        v-btn.justify-end(fab text v-bind="attrs" @click="showSnackBar = false")
          v-icon fal fa-times-circle
    v-card(v-if="boarderList" height="500px")
      v-card-title
        v-row.ma-0(no-gutters)
          v-col.headline.pa-0(cols="12") {{ $t('discountPage.pageTitle') }}
          v-col.pt-2.pa-0(cols="12")
              v-text-field(
                dense
                v-model="filterText"
                clearable clear-icon="fal fa-times" hide-details  prepend-inner-icon="fas fa-search" single-line outlined height="10px"
                @input="onFilterTextInput")
      v-card-text.pa-0(style="height: 34vh; overflow-y: scroll"  )
        v-checkbox.pl-6(on-icon="fas fa-check-square" off-icon="fal fa-square" :label="`${$t('discountPage.selectedAllLabel')}`" @change="selectedAll" v-model="checkBox")
        v-list.ml-2(dense v-if="!saveInProgress")
          v-list-item(v-for="(item, idx) in filteredItemCollection" :key="idx" @click="changeItem(item)")
            template(v-slot:default="{ active }")
              v-list-item-action
                v-checkbox(on-icon="fas fa-check-square" off-icon="fal fa-square" :input-value="selectedBoarderItem.includes(item)" )
              v-list-item-content
                v-row.ma-0(dense)
                  v-col.text-start.pa-0.pt-2(cols="4") {{item.person.firstName}} {{item.person.familyName}}
                  v-col.text-start.pa-0.pt-2(cols="5") {{item.customer.name}}
                  v-col.text-start.pa-0.pt-2(cols="2" v-for="(i, idx) in item.boarderGroupCollection" :key="idx") {{i.name}}

        v-skeleton-loader(v-else type="list-item@10")
      v-divider
      v-card-actions.justify-end
        v-btn(@click="onCloseButtonClick" text ) {{ $t('buttons.closeButtonLabel') }}
        v-btn( color="primary" @click="onSaveButtonClick" :loading="saveInProgress" :disabled="saveInProgress || !formIsValid") {{ $t('buttons.saveButtonLabel') }}

</template>

<script lang="ts">
import Vue from "vue";
import {Component, Prop, Watch} from "vue-property-decorator";
import {usePiniaStore} from "@/store/piniaStore";
import { BOARDER_FETCH_LIST} from "@/store/action-types";
import _, {indexOf, reject} from 'lodash'
import Boarder from "@/model/boarder/Boarder";
import Customer from "@/model/customer/Customer";
import BoarderGroup from "@/model/boarder/BoarderGroup";
import Discount from "@/model/Discount";
@Component({
  components: {}
})
export default class AddBoarderToDiscountGroupDialog extends Vue {

  @Prop({type: Boolean, default: false}) readonly show!: boolean
  @Prop({type: Object, required: false}) readonly selectedItem!: Discount
  @Prop({type: Array, required: false}) readonly boarderList!: Boarder[]
  @Prop({type: Array, required: false}) readonly discountBoarderList!: Boarder[]

  private saveInProgress: boolean = false
  private showSnackBar: boolean = false
  private snackBarColor: string = ''
  private snackBarMessage: string = ''
  private formIsValid: boolean = true
  private name: string = ''
  private value: number = 0
  private showBoarderDialog: boolean = false
  private filterText: string | null = null
  private filteredItemCollection: Boarder[] = []
  private selectedBoarderItem: Boarder[] = []
  private checkBox: boolean = false

  addNewBoarderToDiscountGroupDialogClick () {
    this.showBoarderDialog = true
  }

  onFilterTextInput() {
  }

  changeItem ( item: Boarder) {
    if(this.selectedBoarderItem.includes(item)) {
      this.selectedBoarderItem.splice(this.selectedBoarderItem.indexOf(item), 1)
    } else {
      this.selectedBoarderItem.push(item)
    }
  }

  selectedAll () {
    if(this.checkBox) {
      this.boarderList.forEach((i: Boarder) => {
        this.selectedBoarderItem.push(i)
      })
    } else {
      this.selectedBoarderItem = []
    }
  }

  onCloseButtonClick () {
    this.$emit('close')
    this.$emit('fetch')
  }

  filterItemCollection(): Boarder[] {
      return this.boarderList.filter((i: any) => {
        if (this.filterText && this.filterText.length > 0) {
          const name = `${i.person.firstName} ${i.person.familyName}`
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
              .toLowerCase()

          const filterText = this.filterText
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
              .toLowerCase()
          const foundGroup = i.boarderGroupCollection.find((item: any) => item.name.includes(filterText))

          return name.includes(filterText) || i.customer.name.includes(filterText) || !!foundGroup
        }
        return true
      })
  }

  onSaveButtonClick() {
    let id: string = ''
    let payload: any[] = []
    this.selectedBoarderItem.forEach((item: Boarder) => {
      const data = `/api/food-ordering/boarder/${item.id}`
      id = this.selectedItem.id
      payload.push(data)
    })
    this.discountBoarderList.forEach((item: Boarder) => {
      const data = `/api/food-ordering/boarder/${item.id}`
      id = this.selectedItem.id
      payload.push(data)
    })
    this.$emit('save', payload, id, this.boarderList, true)
    this.$emit('close')

  }


  mounted(): void {

    this.filteredItemCollection = this.filterItemCollection()
    this.onFilterTextInput = _.debounce(() => {
      this.filteredItemCollection = this.filterItemCollection()
    }, 500)

  }
}
</script>

<style lang="stylus" scoped>

</style>